import { RootState } from '../../../base';

export const reportsSelectors = {
    getFunnelData: (state: RootState) => state.reports.funnelData,
    getIsLoadingFunnel: (state: RootState) =>
        state.reports.uiState.isLoadingFunnel,
    getTimeToHireData: (state: RootState) => state.reports.timeToHireData,
    getIsLoadingTimeToHire: (state: RootState) =>
        state.reports.uiState.isLoadingTimeToHire,
    getSourceOfHireStats: (state: RootState) => state.reports.sourceOfHireStats,
    getIsLoadingSourceOfHireStats: (state: RootState) =>
        state.reports.uiState.isLoadingSourceOfHireStats,
    getSourceOfHireChart: (state: RootState) => state.reports.sourceOfHireChart,
    getIsLoadingSourceOfHireChart: (state: RootState) =>
        state.reports.uiState.isLoadingSourceOfHireChart,
    getSourceOfHireFilter: (state: RootState) =>
        state.reports.sourceOfHireFilter,
    getJobsOptions: (state: RootState) => state.reports.jobsOptions,
    getRecruitersOptions: (state: RootState) =>
        state.reports.recruitersOptions,
    getIsLoadingFilterOptions: (state: RootState) =>
        state.reports.uiState.isLoadingFilterOptions,
};
